import { Link } from "@inertiajs/react";
import { PropsWithChildren } from "react";

const Guest = ({ children }: PropsWithChildren) => {
    return (
        <div className="min-h-screen bg-gradientMain relative flex flex-col justify-center">
            <div className="absolute top-0 w-full z-10 h-[52.3%] object-cover object-center bg-[url(@static/accord-symbol-pattern.svg)]"></div>
            <header className="px-14 flex justify-between z-20 relative pt-6 pb-4 items-center mb-auto maxMd:px-4 maxMd:pt-6 maxMd:pb-4 maxMd:mb-10">
                <Link href="/" title="Strona główna">
                    <img
                        src="/storage/static/accord-logo-full.svg"
                        className="max-w-40 w-full h-auto maxMd:max-w-[105px]"
                    />
                </Link>
                {(route().current("register") ||
                    route().current("register.*")) && (
                    <Link href={route("login")} className="outline-btn">
                        Zaloguj się
                    </Link>
                )}
                {(route().current("login") || route().current("login.*")) && (
                    <Link href={route("register")} className="outline-btn">
                        Zarejestruj się
                    </Link>
                )}
            </header>

            <main className="z-20 guest-container my-auto mx-auto">
                <div className="-mx-3 maxMd:-mx-4">
                    <div className="px-3 maxMd:px-4">
                        <div className="w-full">{children}</div>
                    </div>
                </div>
            </main>

            <footer className="px-14 flex justify-center z-20 relative py-5 items-center gap-x-10 mt-auto maxMd:py-4 flex-wrap maxMd:gap-y-4">
                <a
                    href="/polityka-prywatnosci"
                    target="_blank"
                    title="Polityka prywatności"
                    className="text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center"
                >
                    Polityka prywatności
                </a>
                <a
                    href="/regulamin-serwisu"
                    target="_blank"
                    title="Regulamin serwisu"
                    className="text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center"
                >
                    Regulamin serwisu
                </a>
                <Link
                    href={route("front.help")}
                    title="Pomoc"
                    className="text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center"
                >
                    Pomoc
                </Link>
                <a
                    target="_blank"
                    href={`https://www.accord-healthcare.com/pl/`}
                    title="Pomoc"
                    className="text-royalPeriwinkle text-16 leading-6 tracking-[0.24px] maxMd:w-full maxMd:text-center"
                >
                    Mój Accord
                </a>
            </footer>
        </div>
    );
};

export default Guest;
